// import clsx from 'clsx';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import imgLogout from '@/assets/icons/logout.svg';
import { Badge } from '@/components/Badge';
import { formatLargeNumber, formatWalletAddress } from '@/utils/format';

import styles from './ConnectedWallet.module.scss';

type WalletProps = {
  address: string;
  balance: string;
  currency: string;
  icon: string;
  onClick: VoidFunction;
  className?: string;
};

export const ProfileConnectedWallet = observer<WalletProps>(
  ({ onClick, address, balance, currency, icon, className }) => (
    <button
      onClick={onClick}
      className={clsx(
        styles['connected-wallet'],
        'in-col',
        'in-v-between',
        className,
      )}
    >
      <Badge
        className={clsx(
          styles['badge'],
          'in-color-white',
          'in-text-12',
          'in-text-normal',
        )}
      >
        <img height={14} width={14} src={icon} alt="" />
        <span>{formatWalletAddress(address)}</span>
        <img height={12} width={12} src={imgLogout} alt="" />
      </Badge>
      <div className={clsx(styles['currency-name'], 'in-col-center')}>
        <span className="in-text-16">{`${formatLargeNumber(balance)} ${currency}`}</span>
      </div>
    </button>
  ),
);
